// Hook pro vyhledávání míst přes OpenStreetMap Nominatim (https://nominatim.openstreetmap.org/ui/search.html)
import { useState, useEffect } from 'react'
import { useDebounce } from './useDebounce'

const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search'

export function useNominatimSearch(query, { minLength = 3, delay = 500 } = {}) {
  const debouncedQuery = useDebounce(query, delay)
  const [results, setResults] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const q = debouncedQuery.trim()
    if (q.length < minLength) {
      setResults([])
      setError(null)
      return
    }

    const controller = new AbortController()
    setIsLoading(true)
    setError(null)

    const params = new URLSearchParams({
      q,
      format: 'jsonv2',
      limit: '8',
      'accept-language': 'cs',
    })

    fetch(`${NOMINATIM_URL}?${params}`, { signal: controller.signal })
      .then(res => {
        if (!res.ok) throw new Error(`Nominatim vrátil chybu ${res.status}`)
        return res.json()
      })
      .then(data => setResults(Array.isArray(data) ? data : []))
      .catch(err => {
        if (err.name !== 'AbortError') setError('Vyhledávání se nezdařilo')
      })
      .finally(() => setIsLoading(false))

    return () => controller.abort()
  }, [debouncedQuery, minLength])

  return { results, isLoading, error }
}
